import { render, staticRenderFns } from "./UpdateTaskDialog.vue?vue&type=template&id=3dd3c333&scoped=true"
import script from "./UpdateTaskDialog.vue?vue&type=script&lang=js"
export * from "./UpdateTaskDialog.vue?vue&type=script&lang=js"
import style0 from "./UpdateTaskDialog.vue?vue&type=style&index=0&id=3dd3c333&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3dd3c333",
  null
  
)

export default component.exports